<template>
  <div class="i-radio-buttons i-destination-picker" :class="vertical">
    <div class="field-label" v-if="label && optionFormatted.length > 0">
      {{ label }}
    </div>

    <div class="radio-options" v-for="option in optionFormatted" :key="option.value">
      <label :class="{'disabled-label' : option.disabled}">
        <input
          type="radio"
          :name="name"
          :checked="option.value === value"
          :value="option.value"
          :disabled="option.disabled"
          @input="onInput"
        />
        {{ option.label }}
      </label>
      <span class="submit-icon" @click="openDeleteDialog(option.id)">
        <i-generate-image
          image="icons/cancel-icon.svg"
        />
      </span>
    </div>

    <i-button
      class="submit-button border bold setup-new-connection-btn"
      label="Set up new connection"
      @click.stop.prevent="setupNewConnection()"
    />

    <form-builder
      v-if="showSetup"
      :value="formData"
      button-label="Connect"
      :config="globalSetupConnection"
      :submit-action="submitAction"
    />

    <div class="field-hint" v-if="hint">
      {{ hint }}
    </div>

    <i-confirmation-dialog
      ref="deleteConnectionModal"
      title="Delete connection"
      class="delete-confirmation-dialog"
      :confirm-action="deleteConnection"
    >
      <template v-slot:idialog-body>
        Are you sure want to delete the connection? This action cannot be undone.
      </template>
    </i-confirmation-dialog>

    <i-loader :is-loading="isLoading"/>
  </div>
</template>

<script>
import IGenerateImage from "@/components/common/IGenerateImage.vue";
import IButton from "@/components/common/IButton.vue";
import {getSetupConnectionConfig, setupConnection} from "@/services/forms/app/recovery/export"
import IConfirmationDialog from "@/components/common/dialog/IConfirmationDialog.vue";
import {mapGetters} from "vuex";
import ILoader from "@/components/common/ILoader.vue";

export default {
  name: "IDestinationPicker",
  components: {ILoader, IConfirmationDialog, IButton, IGenerateImage},
  props: {
    data: {
      type: Object
    },
    isLoading: {
      type: Boolean
    },
    label: {
      type: String
    },
    hint: {
      type: String,
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean
    },
    vertical: {
      type: String, // horizontal|vertical
    },
    storageDestinationType: {
      type: [String, Number],
    }
  },

  data() {
    return {
      showSetup: false,
      formData: null,
      connectionId: null,
      regionOption: []
    }
  },
  computed: {
    ...mapGetters({
      getFormatedRegions: "salesforce/recovery/salesforce/getListRegions",
      getFormatedRegionsGCP: "salesforce/recovery/salesforce/getListRegionsGcp",
    }),
    globalSetupConnection() {
      return setupConnection(this.storageDestinationType, this.storageDestinationType == 8 ? this.getFormatedRegionsGCP() : this.getFormatedRegions(), 'Region')
    },
    optionFormatted() {
      return this.options.map(option => ({
        label: this.getOptionLabel(option),
        value: this.getOptionValue(option),
        id: option.id,
      }))
    },
  },
  methods: {
    onInput(e) {
      this.$emit('input', e.target.value);
    },
    openDeleteDialog(id) {
      this.connectionId = id;
      this.$refs['deleteConnectionModal'].openModal();
    },
    deleteConnection() {
      return this.$store.dispatch(`salesforce/recovery/salesforce/deleteConnection`, {id: this.connectionId})
        .then(() => {
          this.$emit('refresh')
        })
    },
    setupNewConnection() {
      const { isOauth, actionName } = getSetupConnectionConfig(this.storageDestinationType);

      if (isOauth) {
        return this.$store.dispatch(actionName, { ProviderTenantType: this.$providerTenantVal })
          .then((data) => {
            window.open(data.authorizeUrl);
          });
      } else {
        this.showSetup = !this.showSetup;

        return this.$store.dispatch(actionName)
          .then((data) => {
            this.regionOption = data;
          });
      }
    },
    wathcForParentMessage(e) {
      try {
        const responseObj = JSON.parse(e.data);
        if (responseObj.success === true) {
          this.$notifySuccess('Connection successfully established!');
          this.$emit('refresh');
        }
      } catch (e) {

      }
    },
    submitAction(formData) {
      this.isLoading = true;

      this.formData = {
        ...formData,
        providerTenantType: this.$providerTenantVal,
        storageDestinationType: this.storageDestinationType,
      }

      const connectionModules = {
        1: 'connectAws',
        2: 'connectAzure',
        3: 'connectGoogle',     // if you ever switch to form‑based Google
        4: 'connectMicrosoft',  // … or Microsoft
        5: 'connectDropbox',
        6: 'connectBox',
        7: 'connectS3Compatible',
        8: 'connectGoogleCloud'
      };

      const connectionModule = connectionModules[this.storageDestinationType] || '';

      return this.$store.dispatch(`salesforce/recovery/salesforce/${connectionModule}`, this.formData)
        .then(() => {
          this.$notifySuccess('Connection successfully established!');
          this.isLoading = false;
          this.showSetup = false;
          this.formData = {};
          this.$emit('refresh')
        }).catch((e) => {
          this.$notifyError('Failed to establish connection');
          this.isLoading = false;
          this.showSetup = false;
          this.formData = {};
        })
    },
    getOptionLabel(option) {
      if ([3, 4, 5, 6].includes(option.storageDestinationType)) {
        return option.email;
      } else if (option.storageDestinationType == 1 || option.storageDestinationType == 7 || option.storageDestinationType == 8) {
        return option.bucketName;
      } else if (option.storageDestinationType == 2) {
        return option.containerName;
      }

      return 'NA';
    },
    getOptionValue(option) {
      return option.id;

      // if ([3, 4, 5, 6].includes(option.storageDestinationType)) {
      //   return option.id;
      // }
      // else if (option.storageDestinationType == 1) {
      //   return option.accessKey;
      // }
      // else if (option.storageDestinationType == 2) {
      //   return option.accountKey;
      // }

      // return 'NA';
    }
  },
  created() {
    window.addEventListener('message', this.wathcForParentMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.wathcForParentMessage)
  }
}
</script>

<style lang="scss">
@import "IDestinationPicker";
</style>
